import { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import SmoothScroll from '@/components/site/SmoothScroll';
import Nav from '@/components/site/Nav';
import Hero from '@/components/site/Hero';
import About from '@/components/site/About';
import Team from '@/components/site/Team';
import Services from '@/components/site/Services';
import Industries from '@/components/site/Industries';
import Testimonial from '@/components/site/Testimonial';
import EditorialMarquee from '@/components/site/EditorialMarquee';
import ThoughtLeadership from '@/components/site/ThoughtLeadership';
import FinalCTA from '@/components/site/FinalCTA';
import Footer from '@/components/site/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Site() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <SmoothScroll>
      <div className="App min-h-screen relative">
        <Nav />
        <main>
          <Hero />
          <About />
          <EditorialMarquee />
          <Team />
          <Services />
          <Industries />
          <Testimonial />
          <ThoughtLeadership />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#FFFFFF',
            borderRadius: '0',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
